<template>
  <div class="nav">
  <div class="nav-contain" :style="{ 'background-color': bgc }" v-if="!$store.state.user.showLogin">
    <div class="re-back" @click="backHome" v-if="$store.state.user.showUser">
      <img :src="require('@/assets/image/icon_shouye02.png')" alt="" class="icon-home">
      <div class="text-home">首页</div>
    </div>
    <div class="input-contain">
      <!-- <el-input placeholder="请输入内容" suffix-icon="el-icon-search" v-model="input1">
      </el-input>
      <div class="draw-down">
        <div class="draw-content">
          <div class="draw-item">
            <div class="item-l"></div>
            <div class="item-r"></div>
          </div>
        </div>
      </div> -->
    </div>
    <div class="login" v-if="$store.state.user.token.length == 0" @click="onLogin">登录/注册</div>
    <div class="user" v-else>
      <img :src="require('@/assets/image/head_pic.png')" alt="" class="user-pic">
      <div class="user-draw">
        <div class="user-select">
          <!-- <div class="user-contain">
            <img :src="require('@/assets/image/head_pic.png')" alt="" class="head-pic">
            <div class="user-r">
              <span class="user-name">机智的弗洛里安兰斯伯爵</span>
              <img :src="require('@/assets/image/icon-ordinary-vip.png')" alt="" class="user-vip">
            </div>
          </div>
          <div class="choose">
            <div class="choose-item" v-for="choose in chooseList" :key="choose.name" @click="changeUser(choose.name)">
              <img :src="choose.src" alt="" class="item-pic">
              <span class="item-name">{{ choose.name }}</span>
            </div>
          </div> -->
          <div class="log-out" @click="logOut">
            <!-- <img :src="require('@/assets/image/icon_log_out.png')" alt="" class="icon-out"> -->
            <span>退出登录</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <el-dialog :visible="$store.state.user.showLogin" :show-close="false" @close="onClose">
      <!-- <img :src="require('@/assets/image/logo_menu.png')" alt="" class="login-pic"> -->
      <h1 class="title">瑞韬剧场</h1>
      <div class="login-type" v-if="isLogin">密码登录</div>
      <div class="reg" v-if="!isLogin">
        <span>注册账号</span>
        <span style="opacity: 0.6;margin-left: 32px;" @click="isLogin=true">返回登录</span>
      </div>
      <el-form :model="info" ref="loginForm" :rules="rules">
        <el-form-item prop="userName">
          <el-input v-model="info.userName" placeholder="请输入手机号码"></el-input>
        </el-form-item>
        <el-form-item prop="code" v-if="!isLogin">
          <el-input v-model="info.code" placeholder="请输入验证码">
            <!-- <template v-slot:prefix>
              <img :src="require('@/assets/image/head_aq.png')" alt="" class="head-aq">
            </template> -->
            <template v-slot:suffix>
              <!-- <el-button type="text" :disabled="disableCode" @click="onSendCode">{{ btnText }}</el-button> -->
              <!-- <span style="color: #FF4762;cursor: pointer;" @click="onSendCode">发送验证码</span> -->
            </template>
          </el-input>
          <el-button type="text" :disabled="disableCode" @click="onSendCode">{{ btnText }}</el-button>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" v-model="info.password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <div class="forget-pass" v-if="isLogin">
          <!-- <span>忘记密码？</span> -->
          <span @click="isLogin=false">注册账号</span>
        </div>
        <!-- <el-form-item> -->
          <el-button type="danger" @click="onsubmit">{{ isLogin ? '登录':'注册' }}</el-button>
          <el-checkbox v-model="checked">
            <span class="tip">我已阅读并同意</span>
            <span class="light" @click.stop="$router.push('/userAgreement')">《用户使用协议》</span>
            <span class="light" @click.stop="$router.push('/privacyPolicy')">《隐私政策》</span>
          </el-checkbox>
        <!-- </el-form-item> -->
      </el-form>
    </el-dialog>
</div>
</template>

<script>
import { registerApi, getCodeApi, loginApi } from '@/api/home'
import { removeToken } from '@/utils/auth.js'
const validateId = (rule, value, callback) => {
  if (!(/^[1-9]\d{5}(19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}(\d|X|x)$/.test(value))) {
		callback(new Error('请输入正确的身份证号码'))
	} else {
		callback()
	}
}
export default {
  props: {
    bgc: {
      type: String,
      default: 'transparent'
    }
    // back: {
    //   type: Boolean,
    //   default: false
    // }
    // showLogin: {
    //   type: Boolean,
    //   default: false
    // }
  },
  data () {
    return {
      input1: '',
      // showLogin: false,  
      info: {
        userName: '',
        password: '',
        code: ''
      },
      checked: true,
      chooseList: [
        { src: require('@/assets/image/icon_user_center.png'), name: '个人中心' },
        { src: require('@/assets/image/icon_set.png'), name: '账号设置' }
      ],
      rules: {
        userName: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }  
          // { validator: validateId, trigger: 'blur' }
        ]
      },
      isLogin: true,
      disableCode: false,
      second: 60, // 秒数
      btnText: '发送'
    }
  },
  methods: {
    backHome () {
      this.$router.push('/home')
    },
    // 登录弹窗
    onLogin () {
      this.$store.state.user.showLogin = true
    },
    // 关闭登录弹窗
    onClose () {
      this.$store.state.user.showLogin = false
      this.reset()
      this.$refs.loginForm.resetFields()
      this.isLogin = true
    },
    // 账号选择
    changeUser (name) {
      if (name == '个人中心') this.$router.push()
      if (name == '账号设置') this.$router.push('/account')
    },
    // 发送验证码
    async onSendCode () {
      // if (!this.info.userName) this.$message.error('请输入手机号码')
      if (!/^1[3456789]\d{9}$/.test(this.info.userName)) return this.$message.error('请输入正确的手机号码')
      console.log(1111111)
      this.disableCode = true
      try {
        await getCodeApi(this.info.userName)
        let timer = setInterval(() => {
          if (this.second == 0) {
            this.second = 60
            this.btnText = '重发'
            this.disableCode = false
            clearInterval(timer)
            return
          }
          this.second--
          this.btnText = this.second + 's'
        }, 1000)
      } catch (error) {
        this.disableCode = false
      }
    },
    // 退出登录
    logOut () {
      this.$store.dispatch('user/setUserToken', '')
      removeToken()
      if (this.$route.path == '/account') {
        this.$router.replace('/home')
      }
      // window.location.reload()
    },
    // 登录/注册弹窗
     onsubmit () {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          if (this.checked) {
            if (!this.isLogin) {
              const params = {
                phone: this.info.userName,
                code: this.info.code,
                password: this.info.password
              }
              await registerApi(params)
              this.$message({ message: '注册成功！请登录账号', type: 'success' })
              this.isLogin = true
            } else {
              const res = await loginApi(this.info)
              // console.log(res, '------res')
              this.$message({ message: '登录成功', type: 'success' })
              this.$store.dispatch('user/setUserToken', res.token)
              this.$store.state.user.showLogin = false
              // window.location.reload()
            }
            this.$refs.loginForm.resetFields()
            this.reset()
          } else {
            this.$message({
              message: '请同意协议',
              type: 'warning'
            })
          }
        }
      })
    },
    reset () {
      this.info = {
        userName: '',
        password: '',
        code: ''
        // idCard: ''
      }
    },
    // 首次进入默认登录
    async defaultLogin () {
      const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        })
      const info = {
        userName: '17356524631',
        password: 'qwer1234'
      }
      try {
        const res = await loginApi(info)
        this.$store.dispatch('user/setUserToken', res.token)
        this.$store.state.user.showLogin = false
        loading.close()
      } catch (error) {
        console.log(error)
        loading.close()
      }
    }
  },
  mounted () {
    this.defaultLogin()
    if (!this.$store.state.user.token) this.$store.state.user.showLogin = true
  }
}
</script>

<style lang="scss" scoped>
.nav{
  background-color: transparent;
.nav-contain {
  width: calc(100vw - 172px);
  height: 60px;
  // background-color: transparent;
  background-color: #1A1C1F;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9999;
  .head-aq{
    width: 20px;
    height: 20px;
  }
  .re-back {
    position: absolute;
    left: 40px;
    top: 21px;
    color: #666;
    font-size: 14px;
    display: flex;
    align-items: center;
    cursor: pointer;

    .icon-home {
      width: 18px;
      height: 18px;
      margin-right: 12px;
    }
  }

  .input-contain {
    width: 480px;
    height: 60px;
    // background-color: #fff;
    margin: 0 auto;
    padding: 12px 0;
    position: relative;

    &::v-deep .el-input__inner {
      background-color: #F9F9F9;
      border: none;
      border-radius: 8px;
      caret-color: #333;
      padding-left: 16px;

      &::placeholder {
        color: #999;
      }
    }
    &::v-deep .el-input__icon {
      color: #999;
      font-size: 18px;
    }

    .draw-down {
      position: absolute;
      top: 56px;
      left: 0;
      width: 480px;
      height: 468px;
      padding: 8px 0 0;

      .draw-content {
        width: 100%;
        height: 460px;
        background-color: #2E3033;
        border-radius: 12px;
        padding: 10px;

        .draw-item {
          height: 44px;
          background-color: #2E3033;
          padding: 13px 14px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #fff;

          &:hover {
            background-color: #404347;
          }

          .item-l {
            width: 17px;
            margin-right: 20px;
          }
        }
      }
    }
  }

  .login {
    width: 100px;
    height: 32px;
    background-color: #3377FF;
    border-radius: 16px;
    color: #fff;
    text-align: center;
    line-height: 32px;
    position: absolute;
    top: 14px;
    right: 70px;
    cursor: pointer;
  }

  .user {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    position: absolute;
    top: 10px;
    right: 70px;
    cursor: pointer;

    .user-pic {
      width: 100%;
      height: 100%;
      border-radius: 20px;
    }

    .user-draw {
      width: 120px;
      // width: 280px;
      // height: 260px;
      // background-color: #fff;
      padding-top: 46px;
      display: none;
      position: absolute;
      top: 0px;
      right: 0px;
      z-index: 10000;

      .user-select {
        // height: 216px;
        background-color: #fff;
        border-radius: 12px;
        padding: 10px;

        .user-contain {
          padding: 14px 0 20px 16px;
          display: flex;
          align-items: center;

          .head-pic {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            margin-right: 12px;
          }

          .user-r {
            height: 40px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .user-name {
              color: #333;
              font-size: 12px;
              line-height: 16px;
            }

            .user-vip {
              width: 64px;
              height: 16px;
            }
          }
        }
      }

      .choose {
        height: 68px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .choose-item {
          width: 59px;
          height: 68px;
          background-color: #999;
          border-radius: 8px;
          padding: 10px 0;
          color: rgba(255,255,255,0.6);
          // opacity: 0.6;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;

          &:hover {
            color: rgba(255,255,255,1);
            // color: #fff;
          }

          .item-pic {
            width: 24px;
            height: 24px;
          }

          .item-name {
            // color: #333;
            font-size: 12px;
            line-height: 16px;
          }
        }
      }

      .log-out {
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #3377FF;
        font-size: 14px;
        line-height: 18px;
        border-radius: 8px;
        border: 1px solid #3377FF;
        margin-top: 8px;

        .icon-out {
          width: 18px;
          height: 18px;
          margin-right: 12px;
        }
      }
    }

    &:hover .user-draw {
      display: block;
    }
  }
}
&::v-deep .el-dialog {
    width: 416px;
    background-color: #fff;
    border-radius: 12px;
    padding: 60px 48px;

    .login-pic {
      width: 180px;
      margin-bottom: 40px;
    }
    .title{
      margin-bottom: 40px;
    }
    .login-type {
      color: #333;
      font-size: 14px;
      line-height: 18px;
      margin-bottom: 32px;
    }
    
    .reg{
      display: flex;
      align-items: center;
      color: #333;
      font-size: 14px;
      line-height: 18px;
      margin-bottom: 32px;
      cursor: pointer;
    }
  }

  &::v-deep .el-dialog__header {
    padding: 0;
  }

  &::v-deep .el-dialog__body {
    padding: 0;
  }

  &::v-deep .el-input__inner {
    background-color: #f9f9f9;
    border-radius: 8px;
    border: 1px solid #fff;
    font-size: 16px;
    // padding-left: 36px;
  }
  &::v-deep .el-form-item__content{
      display: flex;
    }
  &::v-deep .el-button--text{
      color: #3377FF;
      width: 80px;
      border: 1px solid #c5d9fff5;
      margin-left: 14px;
      border-radius: 8px;
    }
  &::v-deep .el-icon-user,
  &::v-deep .el-icon-lock {
    font-size: 24px;
    margin-right: 12px;
  }

  .forget-pass {
    color: #333;
    font-size: 14px;
    line-height: 18px;
    // padding-top: 8px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    cursor: pointer;
  }

  &::v-deep .el-button--danger {
    width: 100%;
    height: 40px;
    background-color: #3377FF;
    border-radius: 8px;
    border: none;
    margin-bottom: 14px;
  }

  .tip {
    color: #999;
    // opacity: 0.6;
  }

  .light {
    color: #3377FF;
  }

  &::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #3377FF;
    border-color: #3377FF;
  }
}
</style>